// extracted by mini-css-extract-plugin
export default {"nwes-page-container":"news_nwes-page-container__HC4PC"};